<template>
    <div id="tryout-group">
        <ol class="breadcrumb pull-right">
            <li>
                <router-link :to="{ path: '/' }">Home</router-link>
            </li>
            <li class="active">Paket {{ datase.kelas }}</li>
        </ol>

        <h1 class="page-header">Daftar Paket {{ datase.kelas }}</h1>

        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-inverse">
                    <div class="panel-heading">
                        <h4 class="panel-title">Paket {{ datase.kelas }}</h4>
                    </div>
                    <div class="panel-body">
                        <app-datatable
                            :items="liveClasses"
                            :has-action="false"
                            :has-custom-search="false"
                            :hidenumber="true"
                            :headers="headers"
                            v-on:selected="selectedRow = $event"
                            v-on:dblClicked="editliveClass()"
                            v-on:deleted="deleteliveClass($event)"
                            v-on:changePage="
                                pagination = {
                                    ...pagination,
                                    currentPage: $event,
                                }
                            "
                            v-on:changeSortMode="
                                pagination = { ...pagination, sortMode: $event }
                            "
                            v-on:doSearch="
                                search = {
                                    query: $event.value,
                                    by: headersKey[$event.key],
                                }
                            "
                        />
                    </div>
                </div>
            </div>
        </div>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import AppSpinner from "@/components/plugins/Spinner";
import DataTable from "@/components/plugins/DataTable";
import Moment from "moment";

export default {
    name: "LandingPackagePackageList",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            liveClasses: [],
            datas: null,
            datase: null,
            selectedRow: null,
            isLoading: false,
            search: null,
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            headers: ["ID", "Paket"],
            headersKey: ["id", "paket"],
        };
    },

    mounted: function () {
        this.fetchDatas();
    },

    watch: {},

    methods: {
        async fetchDatas() {
            var context = this;
            this.datas = [];
            try {
                const resp = this.$store.state.landingpackages.data || [];
                var datas = resp.find((ed) => {
                    return ed.id == this.$route.params.id;
                });

                this.datase = datas.list_data.find((ed) => {
                    return ed.kelas == this.$route.params.kelas;
                });

                this.datase.pakets.forEach(function (group) {
                    var row = {
                        id: group.id,
                        data: [group.id, group.deskripsi],
                        datas: group,
                    };

                    context.liveClasses.push(row);

                    context.isLoading = false;
                });
                context.isLoading = false;
            } catch (error) {
                this.$router.push("/landing-packages");
            }
        },

        fetchData: function () {
            var context = this;
            var search = null;
            this.isLoading = true;

            if (
                this.$store.state.datatable.filter &&
                this.$store.state.datatable.pageBefore == "liveClassForm"
            ) {
                search = {
                    query: this.$store.state.datatable.filter.value,
                    by: this.headersKey[this.$store.state.datatable.filter.key],
                };
            } else {
                search = this.search;
            }

            LiveClassService.getListOfliveClasses(function (result) {
                context.liveClasses = [];

                if (result.success) {
                    result.data.forEach(function (group) {
                        var level = group.level ? group.level : "-";

                        var createdAt = Moment(group.createdAt).format(
                            "YYYY-MM-DD",
                        );
                        var row = {
                            id: group.classId,
                            data: [
                                group.name,
                                group.description,
                                group.subject,
                                level,
                                group.grade.toString().replace(/[\[\]']+/g, ""),
                                createdAt,
                            ],
                            datas: group,
                        };

                        context.liveClasses.push(row);

                        context.isLoading = false;
                    });
                }
                context.isLoading = false;
            });
        },

        createliveClass: function () {
            this.$router.push({ path: "form" });
        },

        editliveClass: function () {
            var context = this;
            context.$store.commit("package_onedit", this.selectedRow.datas);
            const infos = {
                categoryId: this.$route.params.id,
                kelasPaket: this.$route.params.kelas,
                idKelas: this.$route.query.idkelas,
                detailId: this.selectedRow.datas.id,
            };
            context.$store.commit("package_info_update", infos);

            context.$router.push({ name: "LandingPackageForm" });
        },

        deleteliveClass: function (tryout) {
            var context = this;
            var groupId = tryout.id;

            var confirmed = window.confirm(
                "Apakah anda yakin akan menghapus Live Class ini?",
            );

            if (confirmed) {
                LiveClassService.deleteLiveClass(groupId, function (result) {
                    if (result.success) {
                        alert("Berhasil menghapus data!");
                        context.fetchData();
                    }
                    context.isLoading = false;
                });
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// ListPackages.vue?dc8f2614